import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Automatically attach the selected language to GET requests
api.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    const lang = localStorage.getItem("lang") || "it";
    config.params = { ...(config.params || {}), lang };
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Qualcosa e andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
